module.exports = __webpack_public_path__ + "img/zulbescheinigung.ebaee05.jpg";